<template>
<v-container fluid style="height: 100%;">
    <v-layout style="flex-direction: column;">
        <v-flex>
            <v-btn v-if="rolusuario == 'Administrador'" @click="BuscarT()" color="primary">Buscar Todo</v-btn>
            <v-select label="Select Executive" v-if="rolusuario == 'Administrador' || rolusuario == 'ComercialAdmin' || rolusuario == 'Finanzas'" v-model="executivo" dense outlined style="width:250px;" v-on:change="listar" :items="ejecutivos"></v-select>
            <v-row>
                <v-col
                    cols="4"
                    lg="2"
                >
                    <v-menu
                    v-model="fechaInicio"
                    dense
                    outlined
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="280px"
                    min-width="auto"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                            outlined
                            dense
                            v-model="computedDateFormattedInicio"
                            label="Fecha Inicio"
                            persistent-hint
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="dateInicio"
                            no-title
                            @input="fechaInicio = false"
                        ></v-date-picker>
                    </v-menu>
                </v-col>
                <v-col
                    cols="4"
                    lg="2" 
                >
                    <v-menu
                    v-model="FechaFin"
                    dense
                    outlined
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="280px"
                    min-width="auto"
                    >
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                        outlined
                        dense
                        v-model="computedDateFormattedFin"
                        label="Fecha Fin"
                        persistent-hint
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="dateFin"
                        no-title
                        @input="FechaFin = false"
                    ></v-date-picker>
                    </v-menu>
                </v-col>
                <v-col >
                    <v-btn style="margin-left: 12px;" @click="Buscar" color="primary">Buscar</v-btn>
                </v-col>
            </v-row>
            <v-data-table
                :headers="headers"
                :items="bs"
                :hide-default-footer="nfooter"
                :items-per-page="pagina"
                class="elevation-1"
                :search="search"
            >
                <template v-slot:[`item.opciones`]="{ item }">
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">                    
                            <v-icon
                            v-bind="attrs"
                            v-on="on"
                                small
                                class="mr-2"
                                @click="editItemP(item)"
                                style="padding: 4px;border: 1px solid #e1e5eb;border-radius: 3px;"
                                color="#3d5170"
                                >
                                edit
                            </v-icon>
                        </template>
                        <span>Edit</span>
                    </v-tooltip>
                    <template v-if="item.activo">
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">                    
                                <v-icon
                                v-bind="attrs"
                                v-on="on"
                                small
                                @click="activarDesactivarMostrar(2,item)"     
                                style="padding: 4px;border: 1px solid #e1e5eb;border-radius: 3px;"
                                color="#3d5170"         
                                >
                                block
                                </v-icon> 
                            </template>
                            <span>Desactivar</span>
                        </v-tooltip>
                    </template>
                    <template v-else>
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">                    
                                <v-icon
                                v-bind="attrs"
                                v-on="on"
                                small 
                                @click="activarDesactivarMostrar(1,item)"                   
                                style="padding: 4px;border: 1px solid #e1e5eb;border-radius: 3px;"
                                color="#3d5170"
                                >
                                check
                                </v-icon>
                            </template>
                            <span>Activar</span>
                        </v-tooltip>
                    </template> 
                </template>
                <template v-slot:[`item.activo`]="{ item }">
                    <template v-if="item.activo === true">
                        <v-icon
                        small
                        class="mr-2"
                        style="color: #4CAF50;font-weight: 600;"
                        >
                        done
                        </v-icon>  
                    </template>
                    <template v-else>
                        <v-icon
                        small
                        class="mr-2"
                        style="color: red;font-weight: 600;"
                        >
                        clear
                        </v-icon> 
                    </template>
                </template>
                <template v-slot:top>
                    <v-toolbar flat color="white">
                        <v-toolbar-title>Report BS</v-toolbar-title>
                        <v-divider
                            class="mx-4"
                            inset
                            vertical
                        ></v-divider>
                        <v-spacer></v-spacer>                        
                        <v-text-field class="text-xs-center" v-model="search" append-icon="search" label="Búsqueda" single-line hide-details></v-text-field>
                        
                        <!-- Boton de Excel Actualizado -->
                        <v-btn color="success" class="ml-2" @click="exportExcel()" :disabled="bs.length === 0">
                            Descargar Excel
                        </v-btn>
                        <v-btn color="info" class="ml-2" @click="exportSegurosExcel()" :disabled="bs.length === 0">
                            <v-icon left>mdi-file-excel</v-icon>
                            Excel Seguros
                        </v-btn>
                    </v-toolbar>
                </template> 
            </v-data-table><br>
            <v-card class="elevation-1">
                    <v-col style="text-align: right;padding: 5px;" v-if="TotalProfit <=0 ">
                        <span style="color: red;">$ {{addCommas(parseFloat(TotalProfit).toFixed(2))}}</span>
                    </v-col>
                    <v-col style="text-align: right;padding: 5px;" v-else>
                        <span >$ {{addCommas(parseFloat(TotalProfit).toFixed(2))}}</span>
                    </v-col>
            </v-card>            
            <v-dialog
                v-model="dialodload"
                hide-overlay
                persistent
                width="300"
            >
                <v-card 
                color="primary"
                dark
                >
                    <v-card-text><br>
                        Please stand by
                    <v-progress-linear
                        indeterminate
                        color="white"
                        class="mb-0"
                    ></v-progress-linear>                    
                    </v-card-text>
                </v-card>
            </v-dialog>   
        </v-flex>
    </v-layout>
</v-container>    
</template>
<script>
import axios from 'axios'
import XLSX from 'xlsx-js-style' // IMPORTACIÓN CORREGIDA

export default {
    data: vm =>({
            pagina:-1,
            nfooter:false,
            fechaInicio: false,
            FechaFin:false,
            dateInicio: '',
            dateFin:'',
            dateFormatted: vm.formatDate((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),
            dialodload:false,
            rate:'',
            ejecutivos:[], 
            fechavigencia:null,
            vigencia:false,
            dialogn:false,
            search:'',
            bs:[],
            BuySellLista:[],
            headers: [
                {text:'Usuario',sortable: false,value: 'nusuario',align:'center'},
                {text:'BS', value: 'nbuysell',align:'center' },
                {text:'OSCAR', value: 'noscar',align:'center' },
                {text:'CUSTOMER', value: 'ncustumer' ,align:'center'},
                {text:'FCH_CREATE', value: 'create' ,align:'center'},
                {text:'POL', value: 'pol' ,align:'center'},
                {text:'ETD', value: 'etd' ,align:'center'},
                {text:'ETA', value: 'eta' ,align:'center'},
                {text:'POD', value: 'pod' ,align:'center'},
                {text:'MODALITY', value: 'modality' ,align:'center'},
                {text:'BASIS', value: 'basis' ,align:'center'},
                {text:'# CONTAINERS', value: 'numcontainer' ,align:'center'},
                {text:'# HBL', value: 'hbln' ,align:'center'},
                {text:'# MBL', value: 'mbln' ,align:'center'},
                {text:'TAMAÑO', value: 'tamaño' ,align:'center'},
                {text:'TIPO', value: 'tipo' ,align:'center'},
                {text:'AGENTE', value: 'agente' ,align:'center'},
                {text:'VENTA', value: 'venta' ,align:'center'},
                {text:'COMPRA', value: 'compra' ,align:'center'},
                {text:'PROFIT', value: 'profit' ,align:'center'},
            ],
            editedIndex:-1,
            usuarios:[],        
            totalbuy:0,
            totalsell:0,
            totalprofitiva:0,
            totalbuyiva:0,
            totalselliva:0,
            pesovolumen:0,
            actualw:0,
            nusuario:'',
            ntipoOp:'',
            nbuysell:'',
            nbasis:'',
            ncustumer:'',
            nfechaeta:'',
            nfechaetd:'',
            nmodalidad:'',
            ncontainer:'',
            ntamaño:'',
            fechacreatebs:'',
            loading:'',
            discharge:'',
            totalbuybs:0,
            totalsellbs:0,
            tprofitbs:0,
            noscar:'',
            executivo:0,
            TotalProfit:0,
            rolusuario:'',
            nagente:'',
            hbln:'',
            mbln:'',
    }),
    created () {        
        this.rolusuario = this.$store.state.usuario.rol;
        this.select();
    },
     computed: {
        computedDateFormattedInicio () {
            return this.formatDate(this.dateInicio)
        },
        computedDateFormattedFin () {
            return this.formatDate(this.dateFin)
        },
    },
    watch: {
      date (val) {
        this.dateFormatted = this.formatDate(this.date)
      },
    },
    methods:{
        select(){
            let me=this;
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            var usuariosarray = [];
            console.log('Reporte')
            console.log(me.$store.state.usuario)
            if(me.$store.state.usuario.idusuario == 1){
                me.ejecutivos.push({text: 'TODOS LOS EJECUTIVOS', value: 0});
            }            
            
            if(me.$store.state.usuario.rol == 'Administrador' || me.$store.state.usuario.rol == 'Finanzas'){
                axios.get('api/Usuarios/SelectBS',configuracion).then(function(response){
                    usuariosarray=response.data;
                    usuariosarray.map(function(x){
                        me.ejecutivos.push({text:x.nombre,value:x.idusuario});
                    });            
                }).catch(function(error){
                    console.log(error);
                });  
            }else{
                axios.get('api/Usuarios/SelectAdminC',configuracion).then(function(response){
                    usuariosarray=response.data;
                    usuariosarray.map(function(x){
                        me.ejecutivos.push({text:x.nombre,value:x.idusuario});
                    });            
                }).catch(function(error){
                    console.log(error);
                }); 
            }
        },
        listar(){
            this.limpiar();
            let me=this;
            me.BuySellLista = [];
            me.bs =[];
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            if(me.$store.state.usuario.rol == 'Administrador'){
                axios.get('api/Oscars/RepoteUsuariosBs/' + me.executivo,configuracion).then(function(response){                
                    me.BuySellLista = response.data;
                    me.oscar();
                }).catch(function(error){
                    console.log(error);
                });
            }
        },
        Buscar(){
            this.limpiar();
            let me=this;
            me.BuySellLista = [];
            me.bs =[];
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};

            if(me.dateInicio == '' || me.dateFin == '')
            {
                axios.get('api/Oscars/RepoteUsuariosBs/' + me.executivo,configuracion).then(function(response){                
                    me.BuySellLista = response.data;
                    me.oscar();
                }).catch(function(error){
                    console.log(error);
                });
            }else{
                if(me.$store.state.usuario.rol == 'Administrador' || me.$store.state.usuario.rol == 'ComercialAdmin' || me.$store.state.usuario.rol == 'Finanzas'){
                    axios.get('api/Oscars/RepoteUsuarioBs/' + me.executivo + '/'+ me.dateInicio + '/' + me.dateFin,configuracion).then(function(response){                
                        me.BuySellLista = response.data;
                        console.log('me.BuySellLista11')
                        console.log(me.BuySellLista)
                        me.oscar();
                    }).catch(function(error){
                        console.log(error);
                    });
                }else{
                    axios.get('api/Oscars/RepoteUsuarioBs/' + me.$store.state.usuario.idusuario + '/'+ me.dateInicio + '/' + me.dateFin,configuracion).then(function(response){                
                        me.BuySellLista = response.data;
                        me.oscar();
                    }).catch(function(error){
                        console.log(error);
                    });
                }
            }
        },
        BuscarT(){
            this.limpiar();
            let me=this;
            me.BuySellLista = [];
            me.bs =[];
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            axios.get('api/Oscars/RepoteUsuariosBsTodo',configuracion).then(function(response){                
                me.BuySellLista = response.data;
                me.oscar();
            }).catch(function(error){
                console.log(error);
            });
        },
        async oscar(){
            if(this.BuySellLista.length > 0){
                var i;
                this.dialodload = true;
                this.TotalProfit = 0;
                for(i=0; i <= this.BuySellLista.length; i++){
                    this.hbln = '';
                    this.mbln = '';
                    if(i != this.BuySellLista.length){
                        this.nusuario = this.BuySellLista[i].nusuario;
                        this.nagente=  this.BuySellLista[i].nagent;
                        this.ntipoOp = this.BuySellLista[i].ntipoOp;
                        this.nbuysell = this.BuySellLista[i].nbuysell;
                        this.nbasis = this.BuySellLista[i].nbasis;
                        this.ncustumer = this.BuySellLista[i].ncustumer;
                        this.nmodalidad = this.BuySellLista[i].nmodalidad;
                        this.fechacreatebs = this.BuySellLista[i].fechacreatebs;
                        if(this.BuySellLista[i].idbasis == 3 || this.BuySellLista[i].idbasis == 4){
                            this.loading = this.BuySellLista[i].receipt;
                            this.discharge = this.BuySellLista[i].delivery;
                        }else{
                            this.loading = this.BuySellLista[i].loading;
                            this.discharge = this.BuySellLista[i].discharge;
                        }
                        this.noscar = this.BuySellLista[i].noscar;
                        if(this.BuySellLista[i].idbasis == 3 || this.BuySellLista[i].idbasis == 4){
                            this.nfechaetd = this.BuySellLista[i].fechaareceipt;
                           this.nfechaeta  = this.BuySellLista[i].fechadelivery;
                        }else{
                            this.nfechaeta= this.BuySellLista[i].nfechaeta;
                            this.nfechaetd = this.BuySellLista[i].nfechaetd;
                        }
                        if(this.BuySellLista[i].idbasis == 1 || this.BuySellLista[i].idbasis == 3 || this.BuySellLista[i].idbasis == 2){
                            await this.CargarInformacion(this.BuySellLista[i].idoscar,this.BuySellLista[i].idbs,this.BuySellLista[i].idbasis);
                        }else{
                            this.ncontainer = '-';
                            this.ntamaño =   '-';
                            await this.ListarChargeBS(this.BuySellLista[i].idbs);
                        }
                    }else{
                        this.dialodload = false;
                    }
                }
            }else{
                window.alert('Sin informacion')
            }
        },
        async CargarInformacion(idoscar,idbs,idbasis){
            let me=this;
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            var container = [];
            me.ncontainer = '';
            me.ntamaño = '';
            me.tarifasListar = [];
            me.infcontainers = [];
            
            if(idbasis == 2){
                await axios.get('api/Containers_pack_oscar_ogl/ListarContainersOscar/'+ idoscar,configuracion).then(async function(response){   
                    container=response.data;
                    me.hbln = container[0].hbln;
                    me.mbln = container[0].mbln;
                }).catch(function(error){
                    console.log(error);
                }); 
            }
            if(idbasis == 1){
                await axios.get('api/Containers_pack_oscar_ogl/ListarContainersOscar/'+ idoscar,configuracion).then(async function(response){                
                    container=response.data;
                    var n = 0;
                    var idsize = 0;
                    var type = '';
                    var size = '';
                    var hbln = '';
                    var hblninf = '';
                    var hblnf = false;
                    var Ncontainer = '';
                    var mbln = '';
                    var mblninf = '';
                    var mblnf = false;
                    for(var i = 0; i < container.length; i++){
                        if(container[i].hbln != ''){
                            if(hblnf == false){
                                hblnf = true;
                                hblninf = container[i].hbln;
                                hbln = container[i].hbln;
                            }
                            if(container[i].hbln != hbln){
                                hblninf = hblninf + ' /-/ '+ container[i].hbln;
                                hbln = container[i].hbln;
                            }
                        }
                        if(container[i].mbln != ''){
                            if(mblnf == false){
                                mblnf = true;
                                mblninf = container[i].mbln;
                                mbln = container[i].mbln;
                            }
                            if(container[i].mbln != mbln){
                                mblninf = mblninf + ' /-/ '+ container[i].mbln;
                                mbln = container[i].mbln;
                            }
                        }
                        me.infcontainers.push({
                            number:container.length,
                            idsize:container[i].idsize,
                            idtype:container[i].idtype,
                            weight:'',
                        });
                        if(n == 0){
                            me.ncontainer = container.length;
                            me.ntamaño =  container[i].size + ' '+  container[i].type;
                            type = container[i].type
                            size = container[i].size;
                            Ncontainer = container[i].size + ' '+  container[i].type;
                        }else{
                            if(Ncontainer != container[i].size + ' '+  container[i].type){
                                me.ncontainer = me.ncontainer + '/-/'+ container.length;
                                me.ntamaño =  me.ntamaño + '/-/' + container[i].size + ' '+  container[i].type;
                                Ncontainer = container[i].size + ' '+  container[i].type;
                            }
                        }
                        n = n + 1;
                    };
                    me.hbln = hblninf;
                    me.mbln = mblninf;
                    await me.ListarChargeBS(idbs);
                }).catch(function(error){
                    console.log(error);
                }); 
             }else{
                await axios.get('api/InlandUnits/ListarContainers/'+ idoscar,configuracion).then(async function(response){
                    container=response.data;
                    var i = 0;
                    var n = 0;
                    var  size = 0;
                    container.map(function(x){
                        n = n + 1;
                            me.infcontainers.push({
                                idcontainer:x.idcontainer,
                                number:container.length,
                                idsize:x.idsize,
                                idtype:x.idtype,
                                weight:me.addCommas(x.grossweight),
                            });
                            size = x.idsize;
                            if(i == 0){
                                me.ncontainer = container.length;
                                me.ntamaño =   x.size + ' '+  x.type;
                            }else{
                                me.ncontainer = me.ncontainer + '/-/'+ container.length;
                                me.ntamaño =  me.ntamaño + '/-/' + x.size + ' '+  x.type;
                            }
                        i = i + 1;
                    }); 
                   await me.ListarChargeBS(idbs);
                }).catch(function(error){
                    console.log(error);
                });
             }
        },
        async ListarChargeBS(idbs){
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            let me=this; 
            var buy=[];
            var sell=[]
            var i;
            var n;
            var tbuy = 0;
            var tsell = 0;
            var total = 0;
            var tbuyiva = 0;
            var tselliva = 0;
            me.totalsell = 0;
            me.totalbuy = 0;
            me.totalselliva = 0;
            me.totalbuyiva = 0;
            me.totalprofitiva = 0;
            me.totalbuybs = 0;
            me.totalsellbs = 0;
            me.tprofitbs = 0;
            var an=0;
            var ans=0;
            await axios.get('api/chargesBS/ListarChargesBuy/' + idbs,configuracion).then(async function(response){                            
                buy=response.data;
                buy.map(async function(x){
                    var totalmxn = 0;
                    if(x.cobrarenpesos == true){
                        totalmxn = me.addCommas(x.totalmxn);
                    } 
                    if(x.payment == 'container'){
                       var nconcainer;
                            an = an + 1;
                            var TotalC = 0;
                            var ncontainer = 0;
                            var TotalMxnC = 0;
                            var ivan = 0;
                                if(x.quantity >= 1){
                                    ncontainer = x.quantity;
                                }else{
                                    ncontainer = me.infcontainers.length;
                                }
                                TotalC = ncontainer * x.total;
                                TotalMxnC = ncontainer * x.totalmxn;
                                ivan = ncontainer * x.iva;

                            tbuyiva = Number(tbuyiva) + Number(TotalC);
                            if(x.prepaid != 0){
                                tbuy = Number(tbuy) + Number(x.prepaid * ncontainer);
                            }
                            if(x.collect != 0){
                                tbuy = Number(tbuy) + Number(x.collect * ncontainer);
                            }
                    }else{
                        if(x.payment == 'TON/m3'){
                            var costo;
                            var iva;   
                            var total;  
                            
                            if(me.pesovolumen >= me.actualw){
                                if(x.prepaid !=''){
                                    costo = me.pesovolumen * x.prepaid;
                                }else{
                                    costo = me.pesovolumen * x.collect;
                                }
                            }else{
                                if(x.prepaid !=''){
                                    costo = me.actualw * x.prepaid;
                                }else{
                                    costo = me.actualw * x.collect;
                                }
                            }
                            iva = Number(costo) * 0.16;
                            total = Number(costo) + Number(iva);
                            an = an + 1;
                        }else{
                            an = an + 1;
                        }
                        tbuyiva = Number(tbuyiva) + Number(x.total);
                        if(x.prepaid != 0){
                            tbuy = Number(tbuy) + Number(x.prepaid);
                        }
                        if(x.collect != 0){
                            tbuy = Number(tbuy) + Number(x.collect);
                        }
                    }
                });
                me.totalbuyiva = parseFloat(Number(tbuyiva)).toFixed(2);
                me.totalbuy = parseFloat(Number(tbuy)).toFixed(2);
                me.totalbuybs = parseFloat(Number(tbuy)).toFixed(2);
                await axios.get('api/chargesBS/ListarChargesSell/' + idbs,configuracion).then(async function(response){
                    sell=response.data;
                    var fin = 0;
                    await sell.map(async function(x){
                        var totalmxn = 0;
                        if(x.cobrarenpesos == true){
                            totalmxn = me.addCommas(x.totalmxn);
                        }
                        if(x.payment == 'container'){
                            ans = ans + 1;
                                var TotalC = 0;
                                var ncontainer = 0;
                                var TotalMxnC = 0;
                                var ivan = 0;
                                if(x.quantity >= 1){
                                    ncontainer = x.quantity;
                                }else{
                                    ncontainer = me.infcontainers.length;
                                }
                                TotalC = ncontainer * x.total;
                                TotalMxnC = ncontainer * x.totalmxn;
                                ivan = ncontainer * x.iva;
                                
                                tselliva = Number(tselliva) + Number(TotalC);
                                if(x.prepaid != 0){
                                    tsell = Number(tsell) + Number(x.prepaid * ncontainer);
                                }
                                if(x.collect != 0){
                                    tsell = Number(tsell) + Number(x.collect * ncontainer);
                                }
                        }else{
                            if(x.payment == 'TON/m3'){
                                    var costo;
                                    var iva;   
                                    var total;  
                                    
                                    if(me.pesovolumen >= me.actualw){
                                        if(x.prepaid !=''){
                                            costo = me.pesovolumen * x.prepaid;
                                        }else{
                                            costo = me.pesovolumen * x.collect;
                                        }
                                    }else{
                                        if(x.prepaid !=''){
                                            costo = me.actualw * x.prepaid;
                                        }else{
                                            costo = me.actualw * x.collect;
                                        }
                                    }
                                    iva = Number(costo) * 0.16;
                                    total = Number(costo) + Number(iva);
                                    an = an + 1;
                                    tselliva = Number(tselliva) + Number(x.total);
                                    if(x.prepaid != 0){
                                        tsell = Number(tsell) + Number(x.prepaid);
                                    }
                                    if(x.collect != 0){
                                        tsell = Number(tsell) + Number(x.collect);
                                    }
                            }else{
                                ans = ans + 1;
                                tselliva = Number(tselliva) + Number(x.total);
                                if(x.prepaid != 0){
                                    tsell = Number(tsell) + Number(x.prepaid);
                                }
                                if(x.collect != 0){
                                    tsell = Number(tsell) + Number(x.collect);
                                }
                            }   
                        }
                        fin = fin + 1;
                    });
                                    
                    me.totalselliva = parseFloat(Number(tselliva)).toFixed(2);
                    me.totalsell = parseFloat(Number(tsell)).toFixed(2);
                    me.totalsellbs = parseFloat(Number(tsell)).toFixed(2);
                    me.tprofit = Number(me.totalsellbs) - Number(me.totalbuybs);
                    await me.total(idbs); 
                }).catch(function(error){
                    console.log(error);
                });
                }).catch(function(error){
                    console.log(error);
                });
        },
        async total(idbs){
            this.TotalProfit = this.TotalProfit + this.tprofit;
            await this.actiualizarprofit(idbs,this.totalbuybs,this.totalsellbs,this.tprofit);
            this.bs.push({
                nusuario:this.nusuario,
                nbuysell:this.nbuysell,
                noscar:this.noscar,
                ncustumer:this.ncustumer,
                create:this.fechacreatebs,
                pol:this.loading,
                etd:this.nfechaetd,
                eta:this.nfechaeta,
                pod:this.discharge,
                modality:this.nmodalidad,
                basis:this.nbasis,
                numcontainer:this.ncontainer,
                hbln:this.hbln,
                mbln:this.mbln,
                tamaño:this.ntamaño,
                tipo:this.ntipoOp,
                agente:this.nagente,
                venta:parseFloat(this.totalsellbs).toFixed(2),
                compra:parseFloat(this.totalbuybs).toFixed(2),
                profit:parseFloat(this.tprofit).toFixed(2),
            });
            this.nfooter = false;
            this.limpiar();
        },
        actiualizarprofit(idbs,compra,venta,profit){
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            axios.put('api/Buysells/ActualizarProfit',{
                'idbs':idbs,
                'ventat':venta,
                'comprat':compra,
                'profitt':profit
            },configuracion).then(function(response){        
                console.log('correcto')
            }).catch(function(error){
                console.log(error);
            });  
        },
        limpiar(){
            this.nusuario = '';
            this.ntipoOp = '';
            this.nbuysell = '';
            this.nbasis = '';
            this.ncustumer = '';
            this.nfechaeta= '';
            this.nfechaetd = '';
            this.nmodalidad = '';
            this.fechacreatebs = '';
            this.loading = '';
            this.discharge = '';
        },
        addCommas(nStr) {
            nStr += '';
            var x = nStr.split('.');
            var x1 = x[0];
            var x2 = x.length > 1 ? '.' + x[1] : '';
            var rgx = /(\d+)(\d{3})/;
            while (rgx.test(x1)) {
                x1 = x1.replace(rgx, '$1' + ',' + '$2');
            }
            return x1 + x2;
        },
        // EXCEL CON ESTILOS, BORDES Y COLORES
        exportExcel: function () {
            const workbook = XLSX.utils.book_new();

            // --- DEFINICIÓN DE COLORES Y ESTILOS ---
            const bordeDelgado = { style: "thin", color: { rgb: "000000" } };
            const bordes = { top: bordeDelgado, bottom: bordeDelgado, left: bordeDelgado, right: bordeDelgado };

            const styleTitulo = { font: { bold: true, sz: 12 }, alignment: { horizontal: "center" } };
            
            // Encabezado Azul (Fondo Azul Claro, Letras Negritas, Centrado, Con Bordes)
            const styleHeaderAzul = { 
                font: { bold: true }, 
                fill: { fgColor: { rgb: "9BC2E6" } }, 
                alignment: { horizontal: "center", vertical: "center" },
                border: bordes
            };

            const styleDato = { border: bordes };
            const styleDatoNumero = { border: bordes, alignment: { horizontal: "right" } };

            // Fila Amarilla (Total)
            const styleTotalAmarillo = { 
                font: { bold: true }, 
                fill: { fgColor: { rgb: "FFFF00" } }, 
                alignment: { horizontal: "center" },
                border: bordes
            };

            // Separador Verde Claro
            const styleSeparadorVerde = { fill: { fgColor: { rgb: "E2EFDA" } } };

            // 1. AGRUPAR LOS DATOS
            let meses = {};
            this.bs.forEach(item => {
                let mesAnio = "SIN FECHA";
                if (item.create && item.create.includes(' ')) {
                    let partes = item.create.split(' ');
                    if (partes.length >= 3) {
                        mesAnio = `${partes[1].toUpperCase()} ${partes[2]}`;
                    }
                }

                if (!meses[mesAnio]) meses[mesAnio] = {};
                
                let ejecutivo = item.nusuario || "EJECUTIVO DESCONOCIDO";
                if (!meses[mesAnio][ejecutivo]) meses[mesAnio][ejecutivo] = [];
                
                meses[mesAnio][ejecutivo].push(item);
            });

            // 2. CREAR PESTAÑAS
            for (const [mes, ejecutivos] of Object.entries(meses)) {
                let sheetData = []; 

                sheetData.push(["", "", "", { v: `REPORTE BS DEL MES DE ${mes}`, s: styleTitulo }]);
                sheetData.push([]);

                let totalGlobalMes = 0;
                let ejecutivosOrdenados = Object.keys(ejecutivos).sort((a, b) => a.localeCompare(b));

                for (let i = 0; i < ejecutivosOrdenados.length; i++) {
                    let ejecutivo = ejecutivosOrdenados[i];
                    let registros = ejecutivos[ejecutivo];

                    sheetData.push(["", { v: `EJECUTIVO: ${ejecutivo.toUpperCase()}`, s: { font: { bold: true } } }]);
                    
                    sheetData.push([
                        "", // Margen A
                        { v: "BS", s: styleHeaderAzul },
                        { v: "CUSTOMER", s: styleHeaderAzul },
                        { v: "POL", s: styleHeaderAzul },
                        { v: "ETD", s: styleHeaderAzul },
                        { v: "ETA", s: styleHeaderAzul },
                        { v: "POD", s: styleHeaderAzul },
                        { v: "BASIS", s: styleHeaderAzul },
                        { v: "# CONTENEDORES", s: styleHeaderAzul },
                        { v: "PROFIT", s: styleHeaderAzul }
                    ]);

                    let totalEjecutivo = 0;

                    registros.forEach(r => {
                        let profitVal = parseFloat(r.profit) || 0;
                        totalEjecutivo += profitVal;
                        totalGlobalMes += profitVal;

                        sheetData.push([
                            "", 
                            { v: r.nbuysell, s: styleDato },
                            { v: r.ncustumer, s: styleDato },
                            { v: r.pol, s: styleDato },
                            { v: r.etd, s: styleDato },
                            { v: r.eta, s: styleDato },
                            { v: r.pod, s: styleDato },
                            { v: r.basis, s: styleDato },
                            { v: r.numcontainer, s: styleDato },
                            { v: profitVal, t: 'n', s: styleDatoNumero } 
                        ]);
                    });

                    sheetData.push([
                        "", "", "", "", "", "", "", 
                        { v: "USD", s: styleTotalAmarillo }, 
                        { v: "TOTAL", s: styleTotalAmarillo }, 
                        { v: parseFloat(totalEjecutivo.toFixed(2)), t: 'n', s: styleTotalAmarillo }
                    ]);
                    
                    sheetData.push([
                        { v: "", s: styleSeparadorVerde }, { v: "", s: styleSeparadorVerde }, 
                        { v: "", s: styleSeparadorVerde }, { v: "", s: styleSeparadorVerde },
                        { v: "", s: styleSeparadorVerde }, { v: "", s: styleSeparadorVerde },
                        { v: "", s: styleSeparadorVerde }, { v: "", s: styleSeparadorVerde },
                        { v: "", s: styleSeparadorVerde }, { v: "", s: styleSeparadorVerde }
                    ]); 
                }

                sheetData.push([]);
                sheetData.push([
                    "", "", "", "", "", "", "", 
                    { v: "TOTAL GLOBAL", s: styleTotalAmarillo }, 
                    { v: "DEL MES", s: styleTotalAmarillo }, 
                    { v: parseFloat(totalGlobalMes.toFixed(2)), t: 'n', s: styleTotalAmarillo }
                ]);

                let ws = XLSX.utils.aoa_to_sheet(sheetData);

                ws['!cols'] = [
                    { wch: 3 },  { wch: 15 }, { wch: 35 }, { wch: 25 }, { wch: 15 }, 
                    { wch: 15 }, { wch: 25 }, { wch: 10 }, { wch: 18 }, { wch: 15 }
                ];

                XLSX.utils.book_append_sheet(workbook, ws, mes.substring(0, 31));
            }

            let nombreArchivo = 'Reporte_Ventas_Mensual';
            if(this.dateInicio && this.dateFin) {
                nombreArchivo += `_${this.dateInicio}_al_${this.dateFin}`;
            }

            XLSX.writeFile(workbook, `${nombreArchivo}.xlsx`);
        },
        formatDate (date) {
            if (!date) return null
            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        },
        parseDate (date) {
            if (!date) return null
            const [month, day, year] = date.split('/')
            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        },
        // EXCEL REPORTE SEGUROS (MÚLTIPLES PESTAÑAS Y ESTILOS)
        exportSegurosExcel() {
            const workbook = XLSX.utils.book_new();

            // --- DEFINICIÓN DE ESTILOS ---
            const bordeDelgado = { style: "thin", color: { rgb: "000000" } };
            const bordes = { top: bordeDelgado, bottom: bordeDelgado, left: bordeDelgado, right: bordeDelgado };

            // Encabezado (Fondo Azul, Letra Blanca, Negrita, Centrado)
            const styleHeader = {
                font: { bold: true, color: { rgb: "FFFFFF" } },
                fill: { fgColor: { rgb: "4472C4" } }, 
                alignment: { horizontal: "center", vertical: "center" },
                border: bordes
            };

            // Celda de Texto Normal Centrado
            const styleNormal = { 
                border: bordes, 
                alignment: { horizontal: "center", vertical: "center" } 
            };

            // Celda Verde Claro (ETD, POD, MODALITY, BASIS)
            const styleVerde = {
                fill: { fgColor: { rgb: "E2EFDA" } },
                border: bordes,
                alignment: { horizontal: "center", vertical: "center" }
            };

            // Celda Dinero/Números a la derecha
            const styleDinero = { 
                border: bordes, 
                alignment: { horizontal: "right", vertical: "center" } 
            };

            // 1. AGRUPAR LOS DATOS POR MODALIDAD Y TIPO (Ej. MARITIMO EXPO)
            let hojas = {};

            this.bs.forEach(item => {
                // Formateamos INLAND a TERRESTRE si aplica, o lo dejamos como venga
                let modalidadRaw = item.modality ? item.modality.toUpperCase() : "OTRO";
                if(modalidadRaw === "INLAND") modalidadRaw = "TERRESTRE";
                
                let tipoRaw = item.tipo ? item.tipo.toUpperCase() : "";
                
                // Nombre de la pestaña: "MARITIMO EXPO", "AEREO IMPO", etc.
                let nombrePestana = `${modalidadRaw} ${tipoRaw}`.trim();

                if (!hojas[nombrePestana]) hojas[nombrePestana] = [];
                hojas[nombrePestana].push(item);
            });

            // 2. CONSTRUIR CADA PESTAÑA (HOJA)
            for (const [nombreHoja, registros] of Object.entries(hojas)) {
                let sheetData = [];

                // Fila 1: Encabezados
                sheetData.push([
                    { v: "BS", s: styleHeader },             
                    { v: "OSCAR", s: styleHeader },
                    { v: "CUSTOMER", s: styleHeader },
                    { v: "FCH_CREATE", s: styleHeader },
                    { v: "POL", s: styleHeader },
                    { v: "ETD", s: styleHeader },
                    { v: "POD", s: styleHeader },
                    { v: "MODALITY", s: styleHeader },
                    { v: "BASIS", s: styleHeader },
                    { v: "# CONTAINERS", s: styleHeader },
                    { v: "TAMAÑO", s: styleHeader },
                    { v: "# HBL", s: styleHeader },
                    { v: "# MBL", s: styleHeader },
                    { v: "TIPO", s: styleHeader },
                    { v: "AGENTE", s: styleHeader },
                    { v: "VENTA", s: styleHeader },
                    { v: "COMPRA", s: styleHeader },
                    { v: "PROFIT", s: styleHeader }
                ]);

                // Filas de Datos
                registros.forEach(r => {
                    // Quitamos el split(' ') para que NO corte el texto si encuentra espacios.
                    // Usamos una pequeña expresión regular solo para borrar la hora (ej. 14:30:00) si es que existe.
                    let fchCreate = r.create ? String(r.create).replace(/\s+\d{1,2}:\d{2}.*/, '').trim() : "-";
                    let fchEtd = r.etd ? String(r.etd).replace(/\s+\d{1,2}:\d{2}.*/, '').trim() : "-";

                    sheetData.push([
                        { v: r.nbuysell || "-", t: 's', s: styleNormal }, 
                        { v: r.noscar || "-", t: 's', s: styleNormal },
                        { v: r.ncustumer || "-", t: 's', s: styleNormal },
                        { v: fchCreate, t: 's', s: styleNormal },             
                        { v: r.pol || "-", t: 's', s: styleNormal },
                        { v: fchEtd, t: 's', s: styleVerde },                 
                        { v: r.pod || "-", t: 's', s: styleVerde },
                        { v: r.modality || "-", t: 's', s: styleVerde },
                        { v: r.basis || "-", t: 's', s: styleVerde },
                        { v: String(r.numcontainer || "-"), t: 's', s: styleNormal },
                        { v: r.tamaño || "-", t: 's', s: styleNormal },
                        { v: r.hbln || "-", t: 's', s: styleNormal },
                        { v: r.mbln || "-", t: 's', s: styleNormal },
                        { v: r.tipo || "-", t: 's', s: styleNormal },
                        { v: r.agente || "Directo", t: 's', s: styleNormal },
                        { v: parseFloat(r.venta) || 0, t: 'n', s: styleDinero }, 
                        { v: parseFloat(r.compra) || 0, t: 'n', s: styleDinero },
                        { v: parseFloat(r.profit) || 0, t: 'n', s: styleDinero }
                    ]);
                });

                // Crear la hoja y aplicarla
                let ws = XLSX.utils.aoa_to_sheet(sheetData);

                // Definir el ancho de las columnas
                ws['!cols'] = [
                    { wch: 15 }, // BS         <--- NUEVO
                    { wch: 18 }, // OSCAR
                    { wch: 35 }, // CUSTOMER
                    { wch: 12 }, // FCH_CREATE
                    { wch: 25 }, // POL
                    { wch: 12 }, // ETD
                    { wch: 30 }, // POD
                    { wch: 12 }, // MODALITY
                    { wch: 10 }, // BASIS
                    { wch: 15 }, // # CONTAINERS
                    { wch: 12 }, // TAMAÑO
                    { wch: 20 }, // # HBL
                    { wch: 20 }, // # MBL
                    { wch: 10 }, // TIPO
                    { wch: 30 }, // AGENTE
                    { wch: 12 }, // VENTA
                    { wch: 12 }, // COMPRA
                    { wch: 12 }  // PROFIT
                ];

                // Limitar el nombre de la pestaña a 31 caracteres (regla de Excel)
                let safeSheetName = nombreHoja.substring(0, 31).replace(/[\\/*?:\[\]]/g, '');
                XLSX.utils.book_append_sheet(workbook, ws, safeSheetName);
            }

            // 3. GENERAR Y DESCARGAR ARCHIVO
            let nombreArchivo = 'SEGUROS_OGL';
            if(this.dateInicio && this.dateFin) {
                nombreArchivo += `_${this.dateInicio}_al_${this.dateFin}`;
            }

            XLSX.writeFile(workbook, `${nombreArchivo}.xlsx`);
        },
    }
}
</script>